import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faRotate } from "@fortawesome/free-solid-svg-icons";
import ComponentCard from "./ComponentCard";
import ProjectSearch from "./ProjectSearch";
import "react-toastify/dist/ReactToastify.css";
import { proxyAPI } from "../../proxyAPI";
import ContactsIcon from "../../../assets/icons/contact_edit.svg2";
import MyPagination from "../../Common/MyPagination";
import LibraryLinks from "../../Library/LibraryLinks";
import PageHeader from "../../Common/PageHeader";
import WhiteButton from "../../Common/WhiteButton";

export default function ComponentCards() {
  const [projects, setProjects] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [resetPagination, setResetPagination] = useState(Date.now());
  const [loading, setLoading] = useState(false);

  const loader = async (page = 0, perPage = 10) => {
    setLoading(true);
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/list-projects?${searchParams.toString()}&offset=${
        page * perPage
      }&limit=${perPage}`,
    });
    setTimeout(() => {
      setLoading(false);
    }, 300);
    if (data?.projects) {
      setTotal(data.total);
      setProjects(data.projects);
    }
  };

  useEffect(() => {
    // reset the projects
    setResetPagination(Date.now());
  }, [searchParams]);

  return (
    <>
      {loading && (
        <div
          className="position-fixed vh-100 vw-100 top-0 start-0 z-3"
          style={{ background: "rgba(0,0,0,0.2)" }}
        >
          <div className="position-fixed top-50 start-50 translate-middle">
            <FontAwesomeIcon icon={faRotate} spin size="5x" />
          </div>
        </div>
      )}

      <PageHeader
        Icon={ContactsIcon}
        heading="Components"
        subheading="Lorem, ipsum dolor sit amet consectetur adipisicing elit."
      >
        <div className="d-flex flex-wrap gap-2">
          <WhiteButton
            as="RRLink"
            icon={ContactsIcon}
            to="/reporting/processes"
            heading="Manage"
            subheading="Processes"
          />
          <WhiteButton
            as="RRLink"
            icon={ContactsIcon}
            to="/inbounds"
            heading="Manage"
            subheading="Inbounds"
          />
        </div>
      </PageHeader>
      <LibraryLinks />
      <div className="mb-5">
        <ProjectSearch />

        <div className="text-center my-3">
          {total} projects found. Showing {projects.length}{" "}
          <Link
            className="btn btn-colored btn-sm ms-3"
            to="/library/logic/builder/new/settings"
          >
            <FontAwesomeIcon icon={faCirclePlus} className="me-2" />
            Create new
          </Link>
        </div>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-5 my-3">
          {projects.map((p) => (
            <div className="col" key={p.UUID}>
              <ComponentCard project={p} />
            </div>
          ))}
        </div>
        <MyPagination total={total} onPaginate={loader} key={resetPagination} />
      </div>
    </>
  );
}
